import { inject } from '@angular/core';
import { ShellEvent, ShellEvents, shellEvent } from '@remote-integration';
import { SharedStateShellEventValues } from '@kaseya-shared';
import { FeaturesFacade } from '@core/features/facades/features.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { ThemeFacade } from '@core/theme/facades/theme.facade';

type SharedStateShellEventSources = { [K in keyof SharedStateShellEventValues]: ShellEvent<SharedStateShellEventValues[K]> };

export const remoteIntegrationShellEventsFactory = (): ShellEvents & SharedStateShellEventSources => ({
  onThemeChange: shellEvent(inject(ThemeFacade).theme),
  onPermissionsChange: shellEvent(inject(PermissionsFacade).permissions),
  onFeaturesChange: shellEvent(inject(FeaturesFacade).features),
});
